import { useApi } from './useApi.js'
import { transformData, transformLabelTapData } from '../schemas/labelTap.js'

export const useLabelReport = () => {
    const { apiCall } = useApi()

    // Create new quick tap
    const createQuickTap = async (url: string) => {
        //http://localhost:3006/?isTestData=true&sd=T010c%7C04ebe300235f17%7C66e3f0dd%7C013eed%7C0138%7C000a%7CeaXWWWWWVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVWZdaZZZYXXYYZaaaaaaaaaaaaaaaaaaaaaaabbbbbbbbbbbbbbbbbbbbbbbbbbbbccccccccccccccccccddddddbbbbbZXWVVVVVVVVWWWWWWWXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXYYYYYYYYYYZZ%7Cf4%7C757f%7C0b8%7C63%7C0000002f%7C1721
        try {
            const { labelReport, token: labelTapToken } = await apiCall({
                //url: 'https://new.api.tapp.online/v2/labelTaps/web',
                url: `${import.meta.env.VITE_TAPP_API_URL}/labelTaps/web`,
                options: {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-db': 'both'
                    },
                    mode: 'cors',
                    body: JSON.stringify({ url })
                },
                retries: 3
            })

            return { labelReport, tokens: { labelReportToken: labelReport.readAccessToken, labelTapToken } }
        } catch (error: any) {
            throw error
        }
    }

    // Parse quick tap data directly
    const parseQuickTapData = async (url: string) => {
        const response = await fetch('/.netlify/functions/parseData', {
            method: 'POST',
            body: JSON.stringify({ url })
        })
        const { data, intervalTimestampData } = await response.json()
        const transformedData = transformData({ data, intervalTimestampData })
        return { data: transformedData }
    }

    const getLabelReport = async (token: string) => {
        //http://localhost:3006/?token=fnEFu5GLVYAA0AViHnJicADLwijS8c9fQqxSOm4UQB-RoVbIj-8
        try {
            const data = await apiCall({
                //url: 'https://new.api.tapp.online/v2/labelReport',
                url: `${import.meta.env.VITE_TAPP_API_URL}/labelReport`,
                options: {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-token': token,
                        'x-db': 'both'
                    },
                    mode: 'cors'
                },
                retries: 3
            })

            return data
        } catch (error: any) {
            return null
        }
    }

    return {
        createQuickTap,
        parseQuickTapData,
        getLabelReport
    }
}
